import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Globe } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';

export const Impressum = () => {
  useSEO('impressum');
  
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-[#264F77] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-normal mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Impressum
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Company Info */}
          <div className="bg-gray-50 rounded-lg p-8 mb-12">
            <h2 className="text-2xl font-semibold text-[#264F77] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              LIVAG AG für Liegenschaften und Verwaltungen
            </h2>
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#264F77]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <MapPin className="text-[#264F77]" size={24} />
              </div>
              <div className="text-gray-700">
                <p>Katharinengasse 4</p>
                <p>9000 St. Gallen</p>
                <p>Schweiz</p>
              </div>
            </div>
          </div>

          {/* Gesamtverantwortung */}
          <div className="mb-12">
            <h2 className="text-2xl font-semibold text-[#264F77] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Gesamtverantwortung
            </h2>
            <div className="space-y-4">
              <div className="flex items-start space-x-4 bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-[#264F77]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Globe className="text-[#264F77]" size={24} />
                </div>
                <div className="text-gray-700">
                  <p className="font-semibold text-[#264F77]">LIVAG</p>
                  <p>Katharinengasse 4</p>
                  <p>CH-9000 St. Gallen</p>
                  <a href="https://www.livag.ch" target="_blank" rel="noopener noreferrer" className="text-[#264F77] hover:underline">
                    www.livag.ch
                  </a>
                </div>
              </div>
              
              <div className="flex items-start space-x-4 bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-[#264F77]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="text-[#264F77]" size={24} />
                </div>
                <div className="text-gray-700">
                  <p className="font-semibold text-[#264F77]">Kontakt</p>
                  <p>Katharinengasse 4</p>
                  <p>CH-9000 St. Gallen</p>
                  <div className="mt-2 space-y-1">
                    <p>
                      <a href="mailto:info@livag.ch" className="text-[#264F77] hover:underline">
                        info@livag.ch
                      </a>
                    </p>
                    <p>
                      <a href="mailto:feedback@livag.ch" className="text-[#264F77] hover:underline">
                        feedback@livag.ch
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bilder und Visualisierungen */}
          <div className="mb-12">
            <h2 className="text-2xl font-semibold text-[#264F77] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Bilder und Visualisierungen
            </h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700">
                Diverse Fotografen und Agenturen
              </p>
            </div>
          </div>

          {/* Links */}
          <div className="pt-8 border-t border-gray-200 flex flex-wrap gap-6 justify-center">
            <Link to="/datenschutz" className="text-[#264F77] hover:text-[#1e3d5c] font-semibold hover:underline">
              Datenschutzerklärung
            </Link>
            <Link to="/kontakt" className="text-[#264F77] hover:text-[#1e3d5c] font-semibold hover:underline">
              Kontakt
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
